import {
  ThemedFunctor, getTypography, TypographyName,
  FontWeight,
} from '@doveit/bricks';
import { css } from 'styled-components';

export const base: ThemedFunctor = ({
  theme,
  $checked,
}) => css`
  ${getTypography(theme, TypographyName.BODY, { lineHeight: '1.2', fontWeight: FontWeight.REGULAR })}
  color: ${$checked ? theme.color.foreground.neutral.default.highest : theme.color.foreground.neutral.disabled.low};
  display: flex;
  align-items: center;
  gap: ${theme.remSize[75]};
`;

export const icon: ThemedFunctor = ({
  theme,
  $checked,
}) => {
  function getIconColor(checked?: boolean) {
    if (checked === undefined) {
      return theme.color.foreground.neutral.disabled.low;
    }

    return checked ? theme.color.foreground.success.default.low : theme.color.foreground.neutral.disabled.low;
  }

  return css`
    color: ${getIconColor($checked)};
    line-height: 0;
    flex-shrink: 0;
  `;
};
